import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { ActionGetPatientPlanList } from '../../../store/Actions/AppConfigAction';

/**
 * Custom hook to handle patient plan data fetching and pagination
 * @param {string} treatmentSlotId - Treatment slot ID from URL
 * @param {string} solutionSlotId - Solution slot ID from URL
 * @returns {Object} Patient plan data, pagination info, and loading state
 */
export const usePatientPlanData = (treatmentSlotId, solutionSlotId) => {
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    /**
     * Load patient plans with pagination
     * @param {number} page - Page number to load
     */
    const loadPatientPlans = (page = 1) => {
        try {
            const queryParam = solutionSlotId
                ? `solutionSlotId=${solutionSlotId}`
                : treatmentSlotId
                    ? `treatmentSlotId=${treatmentSlotId}`
                    : '';

            if (queryParam) {
                setLoading(true);
                setError(null);
                dispatch(
                    ActionGetPatientPlanList({
                        Query: `?${queryParam}&page=${page}&limit=10`,
                    })
                );
            }
        } catch (err) {
            console.error('Error loading patient plan:', err);
            setError('Failed to load patient plan data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadPatientPlans(currentPage);
    }, [treatmentSlotId, solutionSlotId, currentPage]);

    return {
        currentPage,
        setCurrentPage,
        loading,
        error,
        setError,
        loadPatientPlans,
    };
};
